"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { Overlay } from '../Overlay/Overlay.mjs';
import clsx from 'clsx';
import 'mobx';
import 'react';
import { useOverlayController } from '../../lib/controller/overlay/useOverlayController.mjs';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import '@tabler/icons-react';
import '../Icon/Icon.mjs';
import { IconClose } from '../Icon/components/icons/IconClose.mjs';
import styles from './LightBox.module.scss.mjs';
import { TunnelProvider, TunnelExit } from '@mittwald/react-tunnel';
import DivView from '../../views/DivView.mjs';
import ButtonView from '../../views/ButtonView.mjs';

const LightBox = flowComponent("LightBox", (props) => {
  const {
    controller: controllerFromProps,
    children,
    ref: ignoredRef,
    className,
    fitScreen = true,
    ...rest
  } = props;
  const rootClassName = clsx(
    styles.lightBox,
    fitScreen && styles.fitScreen,
    className
  );
  const propsContext = {
    ActionGroup: {
      className: styles.actionGroup,
      Button: { variant: "soft", color: "light" },
      tunnelId: "actionGroup"
    }
  };
  const controllerFromContext = useOverlayController("LightBox", {
    reuseControllerFromContext: true
  });
  const controller = controllerFromProps ?? controllerFromContext;
  return /* @__PURE__ */ jsx(
    Overlay,
    {
      overlayType: "LightBox",
      className: rootClassName,
      controller,
      ...rest,
      children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsxs(TunnelProvider, { children: [
        /* @__PURE__ */ jsx(DivView, { className: styles.content, children }),
        /* @__PURE__ */ jsxs(DivView, { className: styles.actions, children: [
          /* @__PURE__ */ jsx(ButtonView, { color: "light", variant: "soft", onPress: controller.close, children: /* @__PURE__ */ jsx(IconClose, {}) }),
          /* @__PURE__ */ jsx(TunnelExit, { id: "actionGroup" })
        ] })
      ] }) })
    }
  );
});

export { LightBox, LightBox as default };
//# sourceMappingURL=LightBox.mjs.map
